import styled from '@emotion/styled';

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export default SpaceBetween;